export default class MenuBar {
    constructor() {
        let nav = document.getElementById('mega-menu-primary_navigation');
    
        if (nav) {
            nav.addEventListener('mouseover', function(event) {
                if (event.target?.tagName === 'LI' && event.target?.parentElement === nav) {
                    nav.style.setProperty('--decoration-left', event.target.offsetLeft + 'px');
                    nav.style.setProperty('--decoration-width', event.target.offsetWidth + 'px');
                }
            });
    
            nav.addEventListener('mouseleave', function(event) {
                nav.style.setProperty('--decoration-width', '0');
            });
        }
    }
}